import http from "../http-common";

const getListPackages = () => {
  return http.get<any>(`/additional-package-history/list-packages`);
};

const get = (customerId: any) => {
  return http.get<any>(`/additional-package-history/${customerId}`);
};

const getByEmail = (email: any) => {
  return http.get<any>(`/additional-package-history/general/${email}`);
}

const getSuspendTeam = (amazonSuspendedApplicantId: any) => {
  return http.get<any>(`/additional-package-history/suspend-team/${amazonSuspendedApplicantId}`);
};

const AdditionalPackageHistoryService = {
  getListPackages,
  get,
  getByEmail,
  getSuspendTeam
};

export default AdditionalPackageHistoryService;
